import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { t, apiClient } from '@cyberint/common-utils';
import * as S from './styled';

const TXTViewer = ({ file }) => {
  const [text, setText] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);

  useEffect(() => {
    const onUseEffect = async () => {
      if (!file?.url) return;

      setLoading(true);
      setError(false);

      try {
        const response = await apiClient.noCacheClient.get(file.url);
        let content = response.data;

        if (typeof content !== 'string') {
          const LIMIT = 4000;
          try {
            content = JSON.stringify(content);
            if (content.length > LIMIT) {
              content = `${content.substring(0, LIMIT)} ...`;
            }
          } catch {
            content = t('common.preview_not_available_for_file_type');
          }
        }

        setText(content);
        setLoading(false);
      } catch (err) {
        setError(true);
      }
    };

    onUseEffect();
  }, [file?.url]);

  if (loading) {
    return <S.StatusContainer>{t('common.loading_file')}</S.StatusContainer>;
  }

  if (error) {
    return <S.StatusContainer>{t('common.failed_to_load_file')}</S.StatusContainer>;
  }

  return (
    <S.TextContainer>
      <S.TextContent>{text}</S.TextContent>
    </S.TextContainer>
  );
};

TXTViewer.propTypes = {
  file: PropTypes.shape({
    url: PropTypes.string.isRequired
  }).isRequired
};

export default TXTViewer;
